import gsap from "gsap";
import {ScrollTrigger}from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export const setupRoadmapAnimations=({
  sectionRef,
  stageRef,
  trackRef,
  itemRefs,
  roadmapItems
})=>{
  const section=sectionRef.current;
  const stage=stageRef.current;
  const track=trackRef.current;
  const items=itemRefs.current;

  if(!section||!stage||!track||!items.length){
    return;
  }

  const ctx=gsap.context(()=>{

    const progressDots=section.querySelectorAll(
      ".roadmap-progress-dot"
    );

    const setActiveItem=(activeIndex)=>{
      items.forEach((item,index)=>{
        if(!item)return;

        item.classList.toggle(
          "is-active",
          index===activeIndex
        );
      });

      progressDots.forEach((dot,index)=>{
        dot.classList.toggle(
          "is-active",
          index===activeIndex
        );
      });
    };

    const mm = gsap.matchMedia();

    mm.add("(min-width: 601px)", () => {
      const getVerticalDistance=()=>{
        return Math.max(
          0,
          track.scrollHeight - stage.clientHeight
        );
      };

      const getScrollDistance = () => {
        return Math.max(track.scrollHeight * 1.2, getVerticalDistance());
      };

      const updateActiveItem = (progress = 0) => {
        let activeIndex = Math.floor(progress * items.length);
        if (activeIndex >= items.length) {
          activeIndex = items.length - 1;
        }
        if (activeIndex < 0) {
          activeIndex = 0;
        }
        setActiveItem(activeIndex);
      };

      gsap.set(track,{ y: 0, clearProps: "y" });
      updateActiveItem(0);

      const pinTrigger = ScrollTrigger.create({
        trigger: section,
        start: "top 60px",
        end: () => `+=${getScrollDistance()}`,
        pin: true,
        anticipatePin: 1,
        pinSpacing: true,
        invalidateOnRefresh: true,
      });

      const verticalTween = gsap.to(track,{
        y: () => -getVerticalDistance(),
        ease: "none",
        overwrite: "auto",
        scrollTrigger:{
          trigger: section,
          start: "top 60px",
          end: () => `+=${getScrollDistance()}`,
          scrub: 1.5,
          invalidateOnRefresh: true,
          onUpdate: (self) => updateActiveItem(self.progress)
        }
      });

      const resizeHandler=()=>{
        ScrollTrigger.refresh();
      };

      window.addEventListener("resize", resizeHandler);

      const refreshId=requestAnimationFrame(()=>{
        ScrollTrigger.refresh();
        if (verticalTween.scrollTrigger) {
          updateActiveItem(verticalTween.scrollTrigger.progress);
        }
      });

      return () => {
        cancelAnimationFrame(refreshId);
        window.removeEventListener("resize", resizeHandler);
        pinTrigger.kill();
        verticalTween.scrollTrigger?.kill();
        verticalTween.kill();
      };
    });

    mm.add("(max-width: 600px)", () => {
      // Natural flow for mobile
      gsap.set(track, { clearProps: "all" });
      
      const triggers = [];
      
      items.forEach((item, index) => {
        if (!item) return;
        
        const st = ScrollTrigger.create({
          trigger: item,
          start: "top 70%",
          end: "bottom 30%",
          onEnter: () => setActiveItem(index),
          onEnterBack: () => setActiveItem(index),
        });
        
        triggers.push(st);
      });

      // Initial active state
      setActiveItem(0);

      return () => {
        triggers.forEach(t => t.kill());
      };
    });

  },section);

  return()=>{
    ctx.revert();
  };
};